import { css, cx } from 'emotion';

import {
	lightGrey,
	darkGrey,
	blue,
	pink,
	headingMedium,
	headingLarge,
	museo500,
	museo900,
	textBlock,
	mobileMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	tabletLandscapeMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
} from 'inside-out/global-styles';

import DropDownIcon from 'inside-out/images/dropdown-icon.svg';

export const employmentInterestedCardStyle = css({
	background: lightGrey,
	border: lightGrey,
	borderRadius: '6px',
	padding: '24px',
	display: 'block',
	textDecoration: 'none',
	'& h1': cx(
		headingMedium,
		css({
			marginBottom: '12px',
		})
	),
	'& p': cx(
		textBlock,
		css({
			margin: '0 0 24px 0',
		})
	),
});

export const locationSelectorStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	height: '106px',
	width: '100%',
	margin: '0 auto',
	padding: '0 20px',
	display: 'table',
});

export const locationSelectorInnerStyle = css({
	display: 'table-cell',
	verticalAlign: 'middle',
	'& label': {
		...museo500,
		fontSize: '22px',
		lineHeight: '27px',
		marginRight: '55px',
	},
	'& select': {
		marginLeft: '24px',
		border: `1px solid ${lightGrey}`,
		color: darkGrey,
		borderRadius: '4px',
		fontSize: '16px',
		lineHeight: '18px',
		padding: '14px 18px',
		minWidth: '300px',
		appearance: 'none',
		cursor: 'pointer',
		background: `#F6F6F6 url(${DropDownIcon}) no-repeat calc(100% - 16px) center`,
	},
});

export const headerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	'& > h1, & > div': {
		padding: '0 20px',
	},
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	overflowX: 'hidden',
});

export const researchBannerStyle = css({
	background: blue,
	position: 'relative',
	width: '100%',
	height: '280px',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	padding: '0 50px',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		height: 'auto',
		padding: '30px 15px',
	},
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		flexDirection: 'column',
		height: 'auto',
		padding: '30px 15px',
	},
});

export const researchBannerInnerStyle = css({
	flex: 1,

	'& > h2': cx(
		headingLarge,
		css({
			color: '#fff',
		})
	),
	'& > div': css({
		color: '#fff',
	}),
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		top: '0',
		transform: 'none',
	},
});

export const researchBannerButtonSection = css({
	flex: 1,
	flexDirection: 'column',
	width: '100%',
	textAlign: 'center',
	padding: '50px 30px 30px 30px',
});

export const researchButton = css({
	...museo900,
	display: 'inline-block',
	background: pink,
	border: 'none',
	color: '#fff',
	fontSize: '18px',
	lineHeight: '15px',
	letterSpacing: '0.5',
	borderRadius: '4px',
	textTransform: 'uppercase',
	textDecoration: 'none',
	padding: '15px 17px 11px 17px',
});



// WEBPACK FOOTER //
// ./src/page-styles/employment/index.js